import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7bad1612"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "dashboard-grid" }
const _hoisted_2 = { class: "grid-1" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Вітаємо Вас в системі обліку автомайстерні та магазину.", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "В цьому стовпчику буде додаватись якась цікава і корисна інформація.", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, " Від тепер система працює та може використовуватись для перших кроків. ", -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, " Доки стадія проекту знаходится в активній розробці і багато функцій будуть додаватись в майбутньому. ", -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, " Слідкуйте за історією праворуч, щоб розуміти, які зміни були внесені в систему. ", -1))
const _hoisted_8 = { class: "grid-1" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Нижче будуть додаватись зміни які були додані до системи, а також додаткова корисна інформація з вказанням дати.", -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "За допомогою історії Ви зможете точно знати що було додано, або змінено в системі.", -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createTextVNode("Закриті замовлення тепер зберігаються окремо від основної бази системи. Після "),
  /*#__PURE__*/_createElementVNode("span", { class: "font-bold" }, "закриття замовлення"),
  /*#__PURE__*/_createTextVNode(" будь-які дії з іншими модулями системи (склад, клієнти, тощо) не можуть вплинути на закрите замовлення.")
], -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Закриті замовлення тепер можна видаляти. Для цього потрібно розгорнути рядок в таблиці з закритими замовлення, там буде червона кнопка \"Видалити\".", -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-muted text-sm" }, "Закрите замовлення видаляється \"ліниво\", тобто якщо закрите замовлення видаляється, воно зникає з відображення в таблиці, але в базі данних воно не зникає, його можна буде відновити (за зверненням), на випадок якщо закрите замовлення було випадково видалено.", -1))
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createTextVNode("Додан стовпець в таблиці з закритими замовленнями де відображається "),
  /*#__PURE__*/_createElementVNode("span", { class: "font-bold" }, "номер замовлення")
], -1))
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createTextVNode("Ціна товару тепер ділиться на "),
  /*#__PURE__*/_createElementVNode("span", { class: "font-bold" }, "ціну купівлі"),
  /*#__PURE__*/_createTextVNode(" (ціна за якою ви купуєте товар у постачальників) та "),
  /*#__PURE__*/_createElementVNode("span", { class: "font-bold" }, "ціну продажу"),
  /*#__PURE__*/_createTextVNode(" (ціна за якою ви продаєте товар клієнтам)")
], -1))
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Ціна продажу може автоматично вираховуватись за допомогою налаштувань ціни в карточці товару (можна додавати як фіксовану вартість так і в процентах)", -1))
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "У ціни тепер є прив'язка до валюти (наразі є тільки гривня та доллар)", -1))
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Були зроблені незначні правки а також зменшений шрифт при друці", -1))
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Було додано поділ клієнта на фізичну та юридичну особу.", -1))
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createTextVNode("Замовлення діляться на три типи: \"Продаж\", \"Ремонт\" і \"Продаж та Ремонт\"."),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("В залежності від типу ви зможете додати до замовлення відповідно товари, послуги, або і те, і інше.")
], -1))
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Також ви можете зберегти замовлення як чорновик, це означає що ви зберігаєте замовлення для його подальшого редагування та наповнення, наприклад якщо ремонт триває і до нього з часом додаются товари та/або послуги.", -1))
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Важливо! Після закриття замовлення видалити, чи відредагувати його неможливо! Також товари які були вибрані в замовленні (якщо це продаж), будуть списані зі складу. В ситуації, коли на складі менше товару ніж було вказано в замовленні, кількість товарів на складі стане рівнятись нулю.", -1))
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-muted text-sm" }, "Також були зроблені незначні правки і додано захист даних від пошкодження (якщо операція була виконана з помилкою існуючі дані не будуть пошкодженні).", -1))
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Були додані нові поля в товарах:", -1))
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createTextVNode("- "),
  /*#__PURE__*/_createElementVNode("span", { class: "font-bold" }, "Коротка назва"),
  /*#__PURE__*/_createTextVNode(" (використовується для показу в таблиці, а також для друку, якщо назва для друку не була вказана)")
], -1))
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createTextVNode("- "),
  /*#__PURE__*/_createElementVNode("span", { class: "font-bold" }, "Назва для друку"),
  /*#__PURE__*/_createTextVNode(" (заміняє назву товару при друці)")
], -1))
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createTextVNode("- "),
  /*#__PURE__*/_createElementVNode("span", { class: "font-bold" }, "Мінімальна кількість на складі"),
  /*#__PURE__*/_createTextVNode(" (використовується для індикації та пошуку товару кількість якого менша за вказану, а також для формування списку товарів які необхідно замовити)")
], -1))
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createTextVNode("- "),
  /*#__PURE__*/_createElementVNode("span", { class: "font-bold" }, "Максимальна кількість на складі"),
  /*#__PURE__*/_createTextVNode(" (для вказання кількості товарів які мають бути на складі після замовлення, має бути не меншою ніж \"Мінімальна кількість на складі\")")
], -1))

import PageWrapper from "@components/page-wrapper/PageWrapper.vue";
import TextNote from './TextNote.vue';

export default /*#__PURE__*/_defineComponent({
  __name: 'PageDashboard',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(PageWrapper, {
    title: _ctx.$t('navigation.home')
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(TextNote, { title: "Вітаю!" }, {
            default: _withCtx(() => [
              _hoisted_3,
              _hoisted_4
            ]),
            _: 1
          }),
          _createVNode(TextNote, {
            title: "Перший випуск!",
            date: "01.01.2023"
          }, {
            default: _withCtx(() => [
              _hoisted_5,
              _hoisted_6,
              _hoisted_7
            ]),
            _: 1
          })
        ]),
        _createElementVNode("div", _hoisted_8, [
          _createVNode(TextNote, { title: "Історія" }, {
            default: _withCtx(() => [
              _hoisted_9,
              _hoisted_10
            ]),
            _: 1
          }),
          _createVNode(TextNote, {
            title: "🎉 Оновлення модуля \"Замовлення\"",
            beta: "",
            date: "09.01.2024"
          }, {
            default: _withCtx(() => [
              _hoisted_11,
              _hoisted_12,
              _hoisted_13,
              _hoisted_14
            ]),
            _: 1
          }),
          _createVNode(TextNote, {
            title: "🎉 Нова ціна товару | Курс валют",
            beta: "",
            date: "08.02.2023"
          }, {
            default: _withCtx(() => [
              _hoisted_15,
              _hoisted_16,
              _hoisted_17,
              _hoisted_18
            ]),
            _: 1
          }),
          _createVNode(TextNote, {
            title: "Тип клієнта",
            date: "10.01.2023"
          }, {
            default: _withCtx(() => [
              _hoisted_19
            ]),
            _: 1
          }),
          _createVNode(TextNote, {
            title: "🎉 Новий пункт \"Замовлення\"",
            date: "09.01.2023",
            beta: ""
          }, {
            default: _withCtx(() => [
              _hoisted_20,
              _hoisted_21,
              _hoisted_22,
              _hoisted_23
            ]),
            _: 1
          }),
          _createVNode(TextNote, {
            title: "Нові значення в товарах",
            date: "04.01.2023"
          }, {
            default: _withCtx(() => [
              _hoisted_24,
              _hoisted_25,
              _hoisted_26,
              _hoisted_27,
              _hoisted_28
            ]),
            _: 1
          })
        ])
      ])
    ]),
    _: 1
  }, 8, ["title"]))
}
}

})